import fetch from '@/plugin/axios'


export function upload (obj) {
  return fetch({
    url: '/api/ocr/ocrRecord/upload',
    method: 'post',
    data: obj
  })
}

export function page (query) {
  return fetch({
    url: '/api/ocr/ocrRecord/ocrRecordPage',
    method: 'get',
    params: query
  })
}
export function elementList (query) {
  return fetch({
    url: '/api/ocr/ocrElement/list',
    method: 'get',
    params: query
  })
}

export function deleteRecord (id) {
  return fetch({
    url: '/api/ocr/ocrRecord/delete/' + id,
    method: 'delete'
  })
}

export function renewIdentify (id) {
  return fetch({
    url: '/api/ocr/ocrRecord/reIdentify/' + id,
    method: 'post'
  })
}

export function previewPdf (id) {
  return fetch({
    url: '/api/ocr/ocrRecord/previewPdf/' + id,
    method: 'get'
  })
}

// export function downloadExcel (obj) {
//   return fetch({
//     url: '/api/ocr/ocrRecord/exportExcel',
//     method: 'post',
//     data:obj,
//     responseType:"blob"
//   })
// }

export function renewExtract(id){
  return fetch({
    url: '/api/ocr/ocrElement/reExtract/' + id,
    method: 'post'
  })
}

export function updateContent(id,content){
  return fetch({
    url: '/api/ocr/ocrRecord/updateContent' ,
    method: 'put',
    data:{id:id,content:content}
  })
}
